/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function specifications(instance) {
	return {
		/**
		 * @param {number} specificationId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		get: (specificationId, config = {}) => {
			return instance.get(`retailers/specifications/${specificationId}`, config)
		},

		/**
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAll: (pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(`retailers/specifications${params}`, config)
		},

		/**
		 * @param {number} specificationId
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		edit: (specificationId, body, config = {}) => {
			return instance.put(
				`retailers/specifications/${specificationId}`,
				body,
				config
			)
		},

		/**
		 * @param {number} specificationId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		delete: (specificationId, config = {}) => {
			return instance.delete(
				`retailers/specifications/${specificationId}`,
				config
			)
		},

		/**
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (body, config = {}) => {
			return instance.post('retailers/specifications', body, config)
		},

		/**
		 * @param {number} retailerId
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllByRetailerId: (retailerId, pageNumber, pageSize, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `?pageNumber=${pageNumber}&pageSize=${pageSize}`
					: ''
			return instance.get(
				`retailers/${retailerId}/specifications${params}`,
				config
			)
		}
	}
}
